import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const GeneralEmptyState = ({
  title,
  description,
  button,
}: {
  title: string;
  description: string;
  button: ReactNode;
}) => {
  return (
    <Stack alignItems='center' marginY='40px' spacing='24px'>
      <Typography variant='h3' align='center'>
        {title}
      </Typography>
      <Typography variant='subtitle2' maxWidth='540px' align='center'>
        {description}
      </Typography>
      {button}
    </Stack>
  );
};
